(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-with-filter"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // var params = new URLSearchParams(window.location.search);

    // if (!params.get('sort_by')) {
    //   params.set('sort_by', 'best-selling');
    //   params.delete('page');
    //   window.location.search = params.toString();
    //   return;
    // }

    var sortSelects = document.querySelectorAll('.collection-sort__select');

    sortSelects.forEach(function (sortSelect) {
      sortSelect.addEventListener('change', function (event) {
        var params = new URLSearchParams(window.location.search);
        var sortBy = event.target.value;

        if (sortBy) {
          params.set('sort_by', sortBy);
        } else {
          params.delete('sort_by');
        }

        params.delete('page');

        var nextQuery = params.toString();
        window.location.search = nextQuery;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  const headers = document.querySelectorAll(
    '.header_wrapper[data-sticky-enabled="true"][data-sticky-shadow-on-scroll="true"]'
  );

  if (headers.length > 0) {
    const syncStickyShadow = () => {
      const isScrolled = window.scrollY > 0;

      headers.forEach((header) => {
        header.dataset.stickyScrolled = isScrolled ? 'true' : 'false';
      });
    };

    syncStickyShadow();
    window.addEventListener('scroll', syncStickyShadow, { passive: true });
  }

  } catch(e) { console.error(e); }
})();
})();
